import { MapTo } from '@adobe/aem-react-editable-components';
import { ContainerV1, ContainerV1IsEmptyFn, ContainerV1Properties } from '@adobe/aem-core-components-react-spa';

const RESOURCE_TYPE = 'learning-academy/components/custom/sectionitem';

export default MapTo<ContainerV1Properties>(RESOURCE_TYPE)(ContainerV1, {
  isEmpty: ContainerV1IsEmptyFn,
});
